<template>
  <RedesignWebccCheckboxGroup
    class="grid gap-4"
    :class="{ 'animate-pulse': loading }"
    :aria-busy="loading ? 'true' : undefined"
  >
    <template v-if="loading">
      <div :class="GRID_CLASSES">
        <RedesignWebccCheckbox
          v-for="(width, index) in loadingOptions"
          :id="`${name}-${index}`"
          :key="`item-${index}`"
          :type="'group'"
          :value="index"
          :model-value="''"
          disabled
        >
          <slot name="item.loader" :idx="index">
            <RedesignTextLoading :style="{ width: `${width / 16}rem` }" />
          </slot>
        </RedesignWebccCheckbox>
      </div>
    </template>

    <template v-else>
      <div :class="GRID_CLASSES">
        <RedesignWebccCheckbox
          v-for="(option, index) in options.slice(
            0,
            defaultVisibleCount || options.length,
          )"
          :id="`${name}-${index}`"
          :key="`item-${index}`"
          v-model="model"
          :value="option.value"
          :type="'group'"
        >
          <slot name="item" :option="option" />
        </RedesignWebccCheckbox>
      </div>

      <template
        v-if="defaultVisibleCount && options.length > defaultVisibleCount"
      >
        <RedesignWebccDisclosure class="grid gap-4" :name="name">
          <div :class="GRID_CLASSES">
            <RedesignWebccCheckbox
              v-for="(option, index) in options.slice(defaultVisibleCount)"
              :id="`${name}-${index}`"
              :key="`item-${index}`"
              v-model="model"
              :value="option.value"
              :type="'group'"
            >
              <slot name="item" :option="option" />
            </RedesignWebccCheckbox>
          </div>
        </RedesignWebccDisclosure>
      </template>
    </template>
  </RedesignWebccCheckboxGroup>
</template>
<script
  setup
  lang="ts"
  generic="
    TValue extends RedesignWebccCheckboxOptionValue,
    TOption extends FilterOption<TValue>
  "
>
const LOADING_COUNT = 4
const GRID_CLASSES = 'grid grid-cols-1 gap-y-4 sm:grid-cols-3 md:grid-cols-1'

defineSlots<{
  item(props: { option: TOption }): any
  ['item.loader'](props: { idx: number }): any
}>()

const props = withDefaults(
  defineProps<{
    name: string
    loading?: boolean
    loadingItems?: number
    options?: TOption[]
    defaultVisibleCount?: number
  }>(),
  {
    loadingItems: LOADING_COUNT,
    options: () => [],
    defaultVisibleCount: 0,
  },
)

const model = defineModel<TValue[]>({
  required: true,
  default: () => [],
}) as Ref<TValue[]>

const loadingOptions = computed(() =>
  Array.from({ length: props.loadingItems }, () => 40 + Math.random() * 100),
)
</script>
